import { render, staticRenderFns } from "./modifyEmail.vue?vue&type=template&id=f8c2ac48&scoped=true"
import script from "./modifyEmail.vue?vue&type=script&lang=js"
export * from "./modifyEmail.vue?vue&type=script&lang=js"
import style0 from "./modifyEmail.vue?vue&type=style&index=0&id=f8c2ac48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c2ac48",
  null
  
)

export default component.exports